import axiosInstance from "../lib/axiosInstance";

class productsModel {

    constructor() {
        this.base_url = "/products"
        this.base_url2="/reports/product"
    }
    async list(query = []) {

        return (await axiosInstance.get(`${this.base_url}?${new URLSearchParams(query)}`)).data;
    }
    async create(data = []) {
        return await axiosInstance.post(this.base_url, data);
    }
    async update(id, data = []) {
        return await axiosInstance.post(`${this.base_url}/${id}?_method=PUT`, data);
    }
    async destroy(id, data = []) {
        return await axiosInstance.delete(`${this.base_url}/${id}`, data);
    }
    async bulkDestroy(data = []) {
        return await axiosInstance.post(`${this.base_url}/bulk_delete`, data);
    }
    async bulkAction(action, data = []) {
        return await axiosInstance.post(`${this.base_url}/bulk_action/${action}`, data);
    }
    async show(id) {
        return (await axiosInstance.get(`${this.base_url}/${id}`)).data;
    }
    async ExportProduct(data=[]) {
        return await axiosInstance.post(`${this.base_url2}`,data);
    }
     async ImageOrder(data=[]) {
        return await axiosInstance.post(`${this.base_url}/images/sort`,data);
    }


}

export default new productsModel();